<template>
  <div class="less-power">
    <el-button @click="addLess" style="margin-bottom:0.5rem" size="small" type="success" icon="el-icon-plus">添加走势</el-button>
    <div v-for="(msg,index) in lessPowerDate" :key="index" class="save-box">
      <div class="less-power">
        <span class="trend-title">年份</span>
        <el-date-picker
          value-format="yyyy"
          v-model="msg.energyYear"
          type="year"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
      <div class="less-power">
        <span class="trend-title">碳排放值</span>
        <el-input type="number" placeholder="请输入" v-model="msg.energyData">
          <template slot="suffix">吨</template>
        </el-input>
        <el-checkbox v-model="msg.containNeutralize">碳中和</el-checkbox>
      </div>
      <div class="less-power1">
        <span class="trend-title">减排措施</span>
        <el-input maxlength="200" show-word-limit :rows="4" type="textarea" placeholder="请输入" v-model="msg.measures"></el-input>
        <el-button @click="delLessPro(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
    </div>
    <div class="last-save">
      <el-button :loading="lessProLoading" size="small" @click="saveLessPro" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      lessProLoading:false,//加载状态
      lessPowerDate:[
        {energyYear:'',containNeutralize:false,energyData:'',measures:''}
      ]
    }
  },
  mounted(){
    this.getLessPro()
  },
  methods:{
    //保存数据
    saveLessPro(){
      this.lessProLoading = true;
      apis.saveReduction(this.lessPowerDate).then(res=>{
        if(res.code==10000){
          this.lessProLoading = false;
          this.getLessPro()
          this.$message.success('保存成功');
        }else{
          this.lessProLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
    //获取数据
    getLessPro(){
      apis.getReduction().then(res=>{
        if(res.code==10000){
          this.lessPowerDate = res.data.list
        }
      })
    },
    //删除趋势
    delLessPro(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apis.delReduction([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getLessPro()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })     
      }else{
        this.lessPowerDate.splice(index,1)
      }
    },
    //添加一行安全数据
    addLess(){
      this.lessPowerDate.push({energyYear:'',containNeutralize:false,energyData:'',measures:''})
    },
  }
}
</script>
<style lang="less" scoped>
.less-power{ padding-top: 10px;
  .save-box{ margin-bottom: 40px;
    .less-power{ display: inline-block; width: auto; margin-bottom: 15px; }
    .less-power1{
      .el-textarea{ width: 50%; display:inline-block; vertical-align: top;
        .el-textarea__inner{ height: 4rem;}
      }
      .el-button{ margin-left: .6rem;}
    }
  }
  .el-input,.el-select{ display: inline-block; width: 12rem;}
  .el-textarea__inner{ height: 1.8rem; display: inline-block;}
}
</style>